import Image from 'next/image';

import { Box, Heading } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';

import { SanityImage } from '~/components/sanity-image';
import { StandardHeroSection } from '~/components/standard-hero';
import { SanityImageType } from '~/features/page-template/models/image';

export function MicrosoftAiSkillsFestHeroSection({ microsoftLogo }: { microsoftLogo: SanityImageType | null }) {
  return (
    <StandardHeroSection
      backgroundTheme='light'
      backgroundImageSlot={
        <Box height='100%' inset={0} position='absolute' width='100%'>
          <Image
            alt=''
            loading='eager'
            src='/images/backgrounds/microsoft-50-bg.png'
            style={{
              objectFit: 'cover',
              pointerEvents: 'none',
            }}
            fill
          />
        </Box>
      }
      containerProps={{
        minHeight: {
          base: '280px',
          md: '312px',
        },
        alignItems: 'center',
      }}
      contentSlot={
        <Flex alignItems='center' flexDirection='column'>
          {microsoftLogo && (
            <Box mb={10}>
              <SanityImage alt='Microsoft' image={microsoftLogo} loading='eager' />
            </Box>
          )}
          <Heading
            as='h1'
            textAlign='center'
            size={{
              base: 'marketing-3xl',
              md: 'marketing-5xl',
            }}
          >
            Celebrating Microsoft 50 and AI Skills Fest
          </Heading>
        </Flex>
      }
    />
  );
}
